/**
 * List of on-chain trade types.
 */
export const ON_CHAIN_TRADE_TYPE = {
    '10K_SWAP': '10K_SWAP',

    AERODROME: 'AERODROME',
    ACRYPTOS: 'ACRYPTOS',
    ALDRIN_EXCHANGE: 'ALDRIN_EXCHANGE',
    ALGEBRA: 'ALGEBRA',
    ALGEBRA_INTEGRAL: 'ALGEBRA_INTEGRAL',
    ANNEX: 'ANNEX',
    APE_SWAP: 'APE_SWAP',
    ARTH_SWAP: 'ARTH_SWAP',
    ASTRO_SWAP: 'ASTRO_SWAP',
    ASCENT: 'ASCENT',
    AURORA_SWAP: 'AURORA_SWAP',
    AVNU: 'AVNU',

    BABY_SWAP: 'BABY_SWAP',
    BALANCER: 'BALANCER',
    BASE_SWAP: 'BASE_SWAP',
    BEAM_SWAP: 'BEAM_SWAP',
    BI_SWAP: 'BI_SWAP',
    BRIDGERS: 'BRIDGERS',
    BULBA_SWAP: 'BULBA_SWAP',
    BLAZE_SWAP: 'BLAZE_SWAP',
    BRONTO_FINANCE: 'BRONTO_FINANCE',

    CAMELOT: 'CAMELOT',
    CETUS: 'CETUS',
    CHERRY_SWAP: 'CHERRY_SWAP',
    CLAIM_SWAP: 'CLAIM_SWAP',
    COFFEE_SWAP: 'COFFEE_SWAP',
    CREMA_FINANCE: 'CREMA_FINANCE',
    CRO_SWAP: 'CRO_SWAP',
    CRONA_SWAP: 'CRONA_SWAP',
    CROPPER_FINANCE: 'CROPPER_FINANCE',
    CROW_FI: 'CROW_FI',
    CRO_DEX: 'CRO_DEX',
    CURVE: 'CURVE',

    DEDUST: 'DEDUST',
    DEFI_PLAZA: 'DEFI_PLAZA',
    DEFI_SWAP: 'DEFI_SWAP',
    DFYN: 'DFYN',
    DLN: 'DLN',
    DODO: 'DODO',
    DRAGON_SWAP: 'DRAGON_SWAP',
    DYSTOPIA: 'DYSTOPIA',

    ECHO_DEX: 'ECHO_DEX',
    EDDY_FINANCE: 'EDDY_FINANCE',
    ELK: 'ELK',
    ENOSYS: 'ENOSYS',
    ENOSYS_V3: 'ENOSYS_V3',

    FENIX_V2: 'FENIX_V2',
    FENIX_V3: 'FENIX_V3',
    FINKUJIRA: 'FINKUJIRA',
    FUSIONX: 'FUSIONX',
    FRAX_SWAP_V2: 'FRAX_SWAP_V2',

    HONEY_SWAP: 'HONEY_SWAP',
    HORIZONDEX: 'HORIZONDEX',

    JET_SWAP: 'JET_SWAP',
    JOE: 'JOE',
    JUPITER: 'JUPITER',
    JUPITER_SWAP: 'JUPITER_SWAP',
    J_SWAP: 'J_SWAP',

    KIM: 'KIM',
    KYBER_SWAP: 'KYBER_SWAP',
    KUJATA: 'KUJATA',
    KODIAK: 'KODIAK',
    KYO_FINANCE: 'KYO_FINANCE',

    LUA_SWAP: 'LUA_SWAP',
    LIFI: 'LIFI',

    MACARON: 'MACARON',
    MAVERICK: 'MAVERICK',
    MDEX: 'MDEX',
    MERLIN_SWAP: 'MERLIN_SWAP',
    MESH_SWAP: 'MESH_SWAP',
    MM_FINANCE: 'MM_FINANCE',
    MOJITO_SWAP: 'MOJITO_SWAP',
    MUTE_SWAP: 'MUTE_SWAP',

    NET_SWAP: 'NET_SWAP',
    NATIVE_ROUTER: 'NATIVE_ROUTER',

    ODOS: 'ODOS',
    OKC_SWAP: 'OKC_SWAP',
    OKU_SWAP: 'OKU_SWAP',
    ONE_INCH: 'ONE_INCH',
    ONE_MOON: 'ONE_MOON',
    ONE_SOL: 'ONE_SOL',
    OMNIDEX: 'OMNIDEX',
    OOLONG_SWAP: 'OOLONG_SWAP',
    OPEN_OCEAN: 'OPEN_OCEAN',
    ORCA_SWAP: 'ORCA_SWAP',
    OSMOSIS_SWAP: 'OSMOSIS_SWAP',

    PANCAKE_SWAP: 'PANCAKE_SWAP',
    PANCAKE_SWAP_V3: 'PANCAKE_SWAP_V3',
    PANGOLIN: 'PANGOLIN',
    PARA_SWAP: 'PARA_SWAP',
    PEGASYS: 'PEGASYS',
    PHOTON_SWAP: 'PHOTON_SWAP',
    POLYDEX: 'POLYDEX',
    PITEAS: 'PITEAS',

    QUICK_SWAP: 'QUICK_SWAP',
    QUICK_SWAP_V3: 'QUICK_SWAP_V3',

    PULSEX_V1: 'PULSEX_V1',
    PULSEX_V2: 'PULSEX_V2',

    RANGO: 'RANGO',
    RAYDIUM: 'RAYDIUM',
    REF_FINANCE: 'REF_FINANCE',
    REN_BTC: 'REN_BTC',
    ROUTER_SWAP: 'ROUTER_SWAP',

    SABER_STABLE_SWAP: 'SABER_STABLE_SWAP',
    SAROS_SWAP: 'SAROS_SWAP',
    SERUM: 'SERUM',
    SHIBA_SWAP: 'SHIBA_SWAP',
    SMOOTHY: 'SMOOTHY',
    SOLANA: 'SOLANA',
    SOLAR_BEAM: 'SOLAR_BEAM',
    SPACEFI_SWAP: 'SPACEFI_SWAP',
    SPIRIT_SWAP: 'SPIRIT_SWAP',
    SPL_TOKEN_SWAP: 'SPL_TOKEN_SWAP',
    SPOOKY_SWAP: 'SPOOKY_SWAP',
    SOUL_SWAP: 'SOUL_SWAP',
    STELLA_SWAP: 'STELLA_SWAP',
    STONFI: 'STONFI',
    SUN_SWAP: 'SUN_SWAP',
    SURFDEX: 'SURFDEX',
    SUSHI_SWAP: 'SUSHI_SWAP',
    SYNAPSE: 'SYNAPSE',
    SYNC_SWAP: 'SYNC_SWAP',
    SILK_SWAP: 'SILK_SWAP',
    SQUIDROUTER: 'SQUIDROUTER',
    SPARK_DEX: 'SPARK_DEX',
    SPARK_DEX_V3: 'SPARK_DEX_V3',

    SYMBIOSIS_SWAP: 'SYMBIOSIS_SWAP', // Fake to show swap via unknown symbiosis dex

    TONCO_DEX: 'TONCO_DEX',
    TRADER: 'TRADER',
    TRISOLARIS: 'TRISOLARIS',

    IZUMI: 'IZUMI',

    UBE_SWAP: 'UBE_SWAP',
    UNISWAP_V2: 'UNISWAP_V2',
    UNI_SWAP_V3: 'UNI_SWAP_V3',
    UNIZEN: 'UNIZEN',

    VERSE: 'VERSE',
    VIPER_SWAP: 'VIPER_SWAP',
    VOLTAGE_SWAP: 'VOLTAGE_SWAP',
    VOOI: 'VOOI',
    VVS_FINANCE: 'VVS_FINANCE',

    WAGYU_SWAP: 'WAGYU_SWAP',
    WANNA_SWAP: 'WANNA_SWAP',
    WAULT_SWAP: 'WAULT_SWAP',
    WOO_FI: 'WOO_FI',
    WRAPPED: 'WRAPPED',
    WYND: 'WYND',

    YUZU_SWAP: 'YUZU_SWAP',

    XY_DEX: 'XY_DEX',

    ZAPPY: 'ZAPPY',
    ZIP_SWAP: 'ZIP_SWAP',
    ZRX: 'ZRX',
    ZETA_SWAP: 'ZETA_SWAP'
} as const;

/**
 * On-chain trade type.
 */
export type OnChainTradeType = keyof typeof ON_CHAIN_TRADE_TYPE;
